import { isPubAdsService, PubAdsService } from './ad-services/DFP/service-dfp.types';

const d: Document = document;
const w: Window = window;

type ElementType = HTMLScriptElement | HTMLElement | Document | Window;
type CallbackType = (ev: any) => any;
type EventType = keyof HTMLElementEventMap | keyof DocumentEventMap;

export default class UancEvent {
    onReady: (fn: (type?: string) => void) => void;
    add: <T extends keyof HTMLElementEventMap>(eventName: T | string, elem: ElementType | PubAdsService, func: CallbackType) => void;
    remove: <T extends keyof HTMLElementEventMap>(eventName: T | string, elem: ElementType | PubAdsService, func: CallbackType) => void;
    subscribe: (eventName: string, elem: ElementType, func: (msg?: any) => void, msg?: any) => void;
    custom: (eventName: string, detail?: object) => void;
    isHTMLScriptElement: (elem: unknown) => elem is HTMLScriptElement;

    constructor() {
        this.onReady = UancEvent.OnReady;
        this.add = UancEvent.Add;
        this.remove = UancEvent.Remove;
        this.subscribe = UancEvent.Subscribe;
        this.custom = UancEvent.Custom;
        this.isHTMLScriptElement = UancEvent.isHTMLScriptElement;
    }

    static OnReady(fn: (type?: string) => void): void {
        let isWebsiteLoaded: boolean = false;

        const init = (e: Event) => {
            const eventType = e.type as EventType;
            if (eventType === 'readystatechange' && d.readyState !== 'complete') {
                return;
            }
            (eventType === 'load' ? w : d).removeEventListener(eventType, init, false);
            if (!isWebsiteLoaded && (isWebsiteLoaded = true)) {
                fn.call(w, eventType);
            }
        };

        const userAgent = navigator.userAgent.toLowerCase();
        const isOldieBrowser = /msie/.test(userAgent) && !/opera/.test(userAgent);

        if (d.readyState === 'complete' || (!isOldieBrowser && d.readyState === 'interactive')) {
            // TO_DO
            // weryfikacja czy koniecznie jest przekazanie argumentu 'lazy'
            // aktualnie przekazuje bez 'lazy' jeżeli w późniejszej fazie okaże się, że jest gdzieś potrzebne to przekażemy
            // fn.call(w, 'lazy');
            fn.call(w);
        } else {
            d.addEventListener('DOMContentLoaded', init, false);
            d.addEventListener('readystatechange', init, false);
            w.addEventListener('load', init, false);
        }
    }

    static isHTMLScriptElement(elem: unknown): elem is HTMLScriptElement {
        return typeof elem === 'object' && elem !== null && 'tagName' in elem && (elem as Element).tagName.toLowerCase() === 'script';
    }

    static Add<T extends keyof HTMLElementEventMap>(eventName: T | string, elem: ElementType | PubAdsService, func: CallbackType): void {
        if (elem instanceof HTMLElement || this.isHTMLScriptElement(elem) || elem instanceof Document || elem instanceof Window) {
            elem.addEventListener(eventName as keyof HTMLElementEventMap, func, false);
        } else if (isPubAdsService(elem)) {
            elem.addEventListener(eventName as keyof googletag.events.EventTypeMap, func as (event: googletag.events.Event) => void);
        } else {
            (elem as any)[eventName] = func;
        }
    }

    static Remove<T extends keyof HTMLElementEventMap>(eventName: T | string, elem: ElementType | PubAdsService, func: CallbackType): void {
        if (elem instanceof HTMLElement || elem instanceof Document || elem instanceof Window) {
            elem.removeEventListener(eventName as keyof HTMLElementEventMap, func, false);
        } else if (isPubAdsService(elem)) {
            elem.removeEventListener(eventName as keyof googletag.events.EventTypeMap, func as (event: googletag.events.Event) => void);
        } else {
            (elem as any)[eventName] = func;
        }
    }

    static Subscribe(eventName: string, elem: ElementType, func: (msg?: any) => void, msg?: any): void {
        UancEvent.Add(eventName, elem, () => {
            UancEvent.Remove(eventName, elem, () => {});
            msg ? func(msg) : func();
        });
    }

    static Custom(eventName: string, detail?: object) {
        const ev = new CustomEvent(eventName, {
            detail,
            cancelable: false,
            bubbles: false,
        });

        w.dispatchEvent(ev);
    }
}
